export default __webpack_public_path__ + "static/media/icon_texturas_selected.56729688.svg";